module.exports = __webpack_public_path__ + "assets/img/414_menu_img_bg_left.b3336541.svg";